import { RootState } from "store/store";
import { connect } from "react-redux";
import {
    getActiveStep,
    getEnrollId,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-selectors";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import GuestTenantsStep from "./GuestTenantsStep";
import withLoader from "hocs/withLoader/withLoader";
import { fetchEnrollCache } from "store/environments/tenants/enroll-tenant/enroll-tenant-thunks";
import { compose } from "redux";
import { setActiveStepData } from "store/environments/tenants/enroll-tenant/enroll-tenant-actions";

const mapStateToProps = (state: RootState) => ({
    activeStep: getActiveStep(state),
    orchestratorInstanceId: getEnrollId(state),
    activeEnvMoniker: getActiveEnvironmentMoniker(state),
});

const GuestTenantsStepContainer = compose(
    connect(mapStateToProps, { fetchEnrollCache, setActiveStepData }),
    withLoader
)(GuestTenantsStep);

export default GuestTenantsStepContainer;
